module.exports = __webpack_public_path__ + "img/dashboard.8c4dabf7.webp";